/* globals $, controller, globalScene, allTweens */
import legacyIsDesktop from 'helpers/legacyIsDesktop';

export default function updateGlobalScenes () {
  if (legacyIsDesktop()) {

    if (!controller.enabled() && $('body').hasClass('loading')) {
      controller.enabled(true);
      $(window).trigger('slider-stop');
    }

    for (let i = 0; i < globalScene.length; i++) {
      if (!globalScene[i].enabled()) {
        globalScene[i].enabled(true);
      }
    }

  } else {

    $('#history > .wrapper').removeAttr('style');

    if (!controller.enabled() && $('body').hasClass('loading')) {
      controller.enabled(true);
    } else {
      if (globalScene.length !== 0) {
        for (let i = 0; i < globalScene.length; i++) {
          globalScene[i].enabled(false);

        }
        for (let x = 0; x < allTweens.length; x++) {
          allTweens[x].seek(allTweens[x].duration(), false);
        }
      }
    }

    $(window).trigger('slider-start');

  }

}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scenes/updateGlobalScenes.js